var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilSkipProcess } from "../../../utils/utilSkipProcess";
import { utilTime } from "../../../utils/utilTime";
import { ButtonDefault } from "../button-buy/ButtonDefault";
import { ButtonSecondaryMedium } from "../common/ButtonSecondaryMedium";
import { IdIcon } from "../icon/IdIcon";
import { TimerWithIcon } from "../timer-with-icon/TimerWithIcon";
import { HOCTimer } from "../timer/HOCTimer";
var ProgressWithSkip = /** @class */ (function (_super) {
    __extends(ProgressWithSkip, _super);
    function ProgressWithSkip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProgressWithSkip.prototype.render = function () {
        var _a = this.props, skipProcessFactor = _a.skipProcessFactor, remainingTime = _a.remainingTime, onSkip = _a.onSkip, _b = _a.icon, icon = _b === void 0 ? IdIcon.TimeIcn : _b, duration = _a.duration, tooltipLoca = _a.tooltipLoca, iconTextComponent = _a.iconTextComponent, iconTextPosition = _a.iconTextPosition, children = _a.children, _c = _a.fillPercentage, fillPercentage = _c === void 0 ? false : _c;
        var timeLeft = utilTime.secondsLeftTill(remainingTime);
        var skipCost = utilSkipProcess.calculateCostToSkipProcess(timeLeft, skipProcessFactor);
        var percent = fillPercentage ? 100 : utilTime.timerProgressReversed(timeLeft, duration);
        var displayedRemainingTime = fillPercentage ? 0 : remainingTime;
        return (React.createElement("div", { className: "progress-with-skip" },
            React.createElement("div", { className: "progress-with-skip__progress" },
                React.createElement(TimerWithIcon, { remainingTime: displayedRemainingTime, icon: icon, progressPercent: percent, iconStyle: IdStyles.IconExtraLarge, tooltipLoca: tooltipLoca, iconTextComponent: iconTextComponent, iconTextPosition: iconTextPosition }),
                children),
            React.createElement(ButtonDefault, { amount: skipCost, onClick: onSkip, component: ButtonSecondaryMedium, icon: IdIcon.GoldIcn, locaId: IdLoca.skip })));
    };
    ProgressWithSkip = __decorate([
        HOCTimer(false)
    ], ProgressWithSkip);
    return ProgressWithSkip;
}(React.Component));
export { ProgressWithSkip };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/progress-with-skip/ProgressWithSkip.tsx
// module id = 581
// module chunks = 3